import * as React from "react";

import { Box, Button, focusRing, Paper, Snackbar, Stack, Typography } from "@platform/style";

interface WorkCompleteProps {
  onHandleReset: () => void;
  onHandleSnackBar?: (message: string, open: boolean) => void;
  snackBar?: { SnackBarMessage: string; ShowSnackBarMessage: boolean };
}

export default function WorkComplete(props: WorkCompleteProps) {
  return (
    <>
      <Paper
        elevation={0}
        variant="outlined"
        min-height="100vh"
        sx={{
          backgroundColor: "inherit",
          display: "flex",
          flexDirection: "column",
          border: "none",
        }}
      >
        <Stack sx={{ paddingTop: "15px" }} spacing={1} alignItems="center">
          <Typography>You can view and edit your templates in the Template area.</Typography>
          <Button
            aria-label={"Summary Reset"}
            variant="contained"
            sx={{ focusRing, textTransform: "uppercase" }}
            onClick={props.onHandleReset}
          >
            Set Up Another Template
          </Button>
          {
            <Box>
              <Snackbar
                aria-label={"Summary Snackbar"}
                message={props.snackBar?.SnackBarMessage ?? ""}
                open={props.snackBar?.ShowSnackBarMessage || false}
                onClose={() => {
                  if (props?.onHandleSnackBar) {
                    props.onHandleSnackBar("", false);
                  }
                }}
              />
            </Box>
          }
        </Stack>
      </Paper>
    </>
  );
}
